const $ = require("./jquery_with_plugins");
const loadGoogleSubclasses = require("./initializegooglesubclasses");
const maps = require("./maps");

/**
 * Initialize the SDK internal state and globals.
 * @param {String} wgs_public_key
 * @param {String} apiUrl
 * @param {String} dataUrl
 * @param {Function} callback
 * @param {Object} scope
 * @private
 * @memberOf woosmap
 */
function initialize(wgs_public_key, apiUrl, dataUrl, callback, scope) {
    window.woosmap = woosmap || {};
    woosmap.public_key = wgs_public_key;
    woosmap.api_url = apiUrl;
    woosmap.datastore_url = dataUrl;
    woosmap.$ = woosmap.$ || $;

    loadGoogleSubclasses();

    callback.bind(scope)(woosmap);
}

module.exports = initialize;
